import React, { useState } from 'react'
import Input from '../../../CustomUi/input'
import { SelectMulti } from '../../../CustomUi/SelectMulti'
import { Select } from '../../../CustomUi/Select'
import {
  faDna,
  faDroplet,
  faFlaskVial,
  faMicroscope,
  faRecycle,
  faScaleBalanced,
  faSprayCan,
  faTag,
  faTint,
  faVial,
  faWater,
  faWheatAwn,
} from '@fortawesome/free-solid-svg-icons'
import TextArea from '../../../CustomUi/textarea'
import { ParamsFormulacao, ParamsMarca } from '../../../../services/fertilizante/GET'
import { Render } from '../../../CustomUi/render'
import { Box } from '../../../CustomUi/box'
import { Collapse } from 'antd'

interface PropsFormDadosFertilizante {
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  extratoAlga: string
  setExtratoAlga: React.Dispatch<React.SetStateAction<string>>
  extrato_de_alga_descricao: string
  setExtrato_de_alga_descricao: React.Dispatch<React.SetStateAction<string>>
  densidade: string
  setDensidade: React.Dispatch<React.SetStateAction<string>>
  aminoacido: string
  setAminoacido: React.Dispatch<React.SetStateAction<string>>
  solubilidade: string
  setSolubilidade: React.Dispatch<React.SetStateAction<string>>
  concentracao_hormonio_regulador: string
  setConcentracao_hormonio_regulador: React.Dispatch<React.SetStateAction<string>>
  descricao_hormonio_regulador: string
  setDescricao_hormonio_regulador: React.Dispatch<React.SetStateAction<string>>
  concentracao_aminoacido: string
  setConcentracao_aminoacido: React.Dispatch<React.SetStateAction<string>>
  descricao_aminoacido: string
  setDescricao_aminoacido: React.Dispatch<React.SetStateAction<string>>
  concentracao_indutor_resistencia: string
  setConcentracao_indutor_resistencia: React.Dispatch<React.SetStateAction<string>>
  descricao_indutor_resistencia: string
  setDescricao_indutor_resistencia: React.Dispatch<React.SetStateAction<string>>
  concentracao_biologicos: string
  setConcentracao_Biologicos: React.Dispatch<React.SetStateAction<string>>
  descricao_biologicos: string
  setDescricao_Biologicos: React.Dispatch<React.SetStateAction<string>>
  ponto_deliquescencia: string
  setPonto_deliquescencia: React.Dispatch<React.SetStateAction<string>>
  indice_salino: string
  setIndice_salino: React.Dispatch<React.SetStateAction<string>>
  funcao: { descr: string; id: number; key?: number }[]
  setFuncao: React.Dispatch<React.SetStateAction<{ descr: string; id: number; key?: number }[]>>
  aplicaçoes: { descr: string; id: number; key?: number }[]
  setAplicaçoes: React.Dispatch<React.SetStateAction<{ descr: string; id: number; key?: number }[]>>
  formulacao: string
  setFormulacao: React.Dispatch<React.SetStateAction<string>>
  setFormulacaoId: React.Dispatch<React.SetStateAction<number>>
  marca: string
  setMarca: React.Dispatch<React.SetStateAction<string>>
  setMarcaId: React.Dispatch<React.SetStateAction<number>>
  aminoacidoPossuiDados: boolean
  hormonioReguladorPossuiDados: boolean
  indutorResistenciaPossuiDados: boolean
  biologicosPosseuiDados: boolean
  extratoAlgaPossuiDados: boolean
  data_aplicacoes: any[]
  data_funcoes: any[]
  data_formulacao: ParamsFormulacao[]
  data_marca: ParamsMarca[]
  setUltimoCampo?: React.Dispatch<React.SetStateAction<string>>
  nomeRef?: React.Ref<HTMLInputElement>
  formulacaoRef?: React.Ref<HTMLInputElement>
  marcaRef?: React.Ref<HTMLInputElement>
  funcaoRef?: React.Ref<HTMLInputElement>
  aplicacaoRef?: React.Ref<HTMLInputElement>
  solubilidadeRef?: React.Ref<HTMLInputElement>
  pontoDeliquescênciaRef?: React.Ref<HTMLInputElement>
  indiceSalinoRef?: React.Ref<HTMLInputElement>
  densidadeRef?: React.Ref<HTMLInputElement>
  concentracao_aminoacidoRef?:React.Ref<HTMLInputElement>
  concentracao_hormonio_reguladorRef?:React.Ref<HTMLInputElement>
  concentracao_indutor_resistenciaRef?:React.Ref<HTMLInputElement>
  concentracao_biologicosRef?:React.Ref<HTMLInputElement>
  concentracao_extratoRef?: React.Ref<HTMLInputElement>
  descricao_aminoacidoRef?:React.Ref<HTMLTextAreaElement>
  descricao_hormonio_reguladorRef?:React.Ref<HTMLTextAreaElement>
  descricao_indutor_resistenciaRef?:React.Ref<HTMLTextAreaElement>
  descricao_biologicosRef?:React.Ref<HTMLTextAreaElement>
  descricao_extratoRef?: React.Ref<HTMLTextAreaElement>
  observacaoRef?: React.Ref<HTMLTextAreaElement>
}

export const FormDadosFertilizante: React.FC<PropsFormDadosFertilizante> = ({
  nome,
  setNome,
  observacao,
  setObservacao,
  extratoAlga,
  setExtratoAlga,
  extrato_de_alga_descricao,
  setExtrato_de_alga_descricao,
  densidade,
  setDensidade,
  indice_salino,
  setIndice_salino,
  funcao,
  setFuncao,
  solubilidade,
  setSolubilidade,
  concentracao_hormonio_regulador,
  setConcentracao_hormonio_regulador,
  descricao_hormonio_regulador,
  setDescricao_hormonio_regulador,
  concentracao_aminoacido,
  setConcentracao_aminoacido,
  descricao_aminoacido,
  setDescricao_aminoacido,
  concentracao_indutor_resistencia,
  setConcentracao_indutor_resistencia,
  descricao_indutor_resistencia,
  setDescricao_indutor_resistencia,
  concentracao_biologicos,
  setConcentracao_Biologicos,
  descricao_biologicos,
  setDescricao_Biologicos,
  ponto_deliquescencia,
  setPonto_deliquescencia,
  aplicaçoes,
  setAplicaçoes,
  formulacao,
  setFormulacao,
  setFormulacaoId,
  marca,
  setMarca,
  setMarcaId,
  aminoacidoPossuiDados,
  hormonioReguladorPossuiDados,
  indutorResistenciaPossuiDados,
  biologicosPosseuiDados,
  extratoAlgaPossuiDados,
  data_aplicacoes,
  data_funcoes,
  data_formulacao,
  data_marca,
  setUltimoCampo,
  nomeRef,
  formulacaoRef,
  marcaRef,
  funcaoRef,
  aplicacaoRef,
  solubilidadeRef,
  pontoDeliquescênciaRef,
  indiceSalinoRef,
  densidadeRef,
  concentracao_aminoacidoRef,
  concentracao_hormonio_reguladorRef,
  concentracao_indutor_resistenciaRef,
  concentracao_biologicosRef,
  concentracao_extratoRef,
  descricao_aminoacidoRef,
  descricao_hormonio_reguladorRef,
  descricao_indutor_resistenciaRef,
  descricao_biologicosRef,
  descricao_extratoRef,
  observacaoRef,
}) => {
  const { Panel } = Collapse
  const [openAplicacao, setOpenAplicacao] = useState<boolean>(false)
  const [openFuncao, setOpenFuncao] = useState<boolean>(false)
  const [openFormulacao, setOpenFormulacao] = useState<boolean>(false)
  const [openMarca, setOpenMarca] = useState<boolean>(false)
  const aplicacoesPonto = ['Foliar', 'Ts', 'Sulco']

  function mascaraDecimal(data, input) {
    let area = data.replace(/\D/g, '')
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')

    if (input === 'd') {
      setDensidade(area)
    }

    if (input === 'ca') {
      setConcentracao_aminoacido(area)
    }

    if (input === 'i') {
      setIndice_salino(area)
    }

    if (input === 's') {
      setSolubilidade(area)
    }

    if (input === 'pd') {
      setPonto_deliquescencia(area)
    }

    if (input === 'cha') {
      setConcentracao_hormonio_regulador(area)
    }

    if (input === 'cir') {
      setConcentracao_indutor_resistencia(area)
    }

    if (input === 'cb') {
      setConcentracao_Biologicos(area)
    }

    if (input === 'cex') {
      setExtratoAlga(area)
    }
  }

  return (
    <>
      <Input
        label='Nome'
        icon={faWheatAwn}
        placeholder='Digite o nome do fertilizante'
        value={nome}
        onChange={setNome}
        
      />
      <div className='campo__dois__inputs'>
        <Select
          label='Formulação'
          placeholder='Selecione a formulação'
          icon={faVial}
          value={formulacao}
          onChange={setFormulacao}
          onChangeID={setFormulacaoId}
          open={openFormulacao}
          trigger={setOpenFormulacao}
          items={data_formulacao}
          descricaoItem={'nome'}
          idItem={'cod'}
          
        />
        <Select
          label='Fabricante/Misturadora'
          placeholder='Selecione o fabricante'
          icon={faTag}
          value={marca}
          onChange={setMarca}
          onChangeID={setMarcaId}
          open={openMarca}
          trigger={setOpenMarca}
          items={data_marca}
          descricaoItem={'nome'}
          idItem={'cod'}
          
        />
      </div>

      <SelectMulti
        label='Função'
        placeholder='Selecione as funções'
        icon={faRecycle}
        open={openFuncao}
        trigger={setOpenFuncao}
        items={data_funcoes}
        descricaoItem={'nome'}
        idItem={'cod'}
        selecteds={funcao}
        onChange={setFuncao}
       
      />

      <SelectMulti
        label='Aplicações'
        placeholder='Selecione as aplicações'
        icon={faSprayCan}
        open={openAplicacao}
        trigger={setOpenAplicacao}
        items={data_aplicacoes}
        descricaoItem={'nome'}
        idItem={'cod'}
        selecteds={aplicaçoes}
        onChange={setAplicaçoes}
       
      />

      <Render
        condition={
          formulacao === 'Sólido' && aplicaçoes.some((item) => aplicacoesPonto.includes(item.descr))
        }
      >
        <Input
          label='Solubilidade (g/L)'
          icon={faWater}
          placeholder='Digite o valor da solubilidade'
          value={solubilidade}
          onChange={(e) => mascaraDecimal(e, 's')}
         
        />
      </Render>

      <Render
        condition={
          formulacao === 'Sólido' && aplicaçoes.some((item) => aplicacoesPonto.includes(item.descr))
        }
      >
        <Input
          label='Ponto de deliquescência (UR%)'
          icon={faFlaskVial}
          placeholder='Digite o valor do ponto de deliquescência'
          value={ponto_deliquescencia}
          onChange={(e) => mascaraDecimal(e, 'pd')}
          
        />
      </Render>

      <Render
        condition={
          aplicaçoes.some((item) => item.descr === 'Sulco') ||
          aplicaçoes.some((item) => item.descr === 'Ts')
        }
      >
        <Input
          label='Índice salino'
          icon={faMicroscope}
          placeholder='Digite o valor do índice salino'
          value={indice_salino}
          onChange={(e) => mascaraDecimal(e, 'i')}
          
        />
      </Render>

      <Render condition={formulacao === 'Líquido'}>
        <Input
          label='Densidade (kg/L)'
          icon={faScaleBalanced}
          placeholder='Digite o valor da densidade'
          value={densidade}
          onChange={(e) => mascaraDecimal(e, 'd')}
          
        />
      </Render>
      <Box style={{ padding: 0 }} borderless>
        <Collapse accordion destroyInactivePanel>
          <Panel
            header={
              <div>
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontWeight: aminoacidoPossuiDados ? 'bold' : 'normal',
                    color: aminoacidoPossuiDados ? '#5DA57D' : 'black',
                  }}
                >
                  Aminoácido
                </p>
              </div>
            }
            key={''}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Input
                label='Concentração (%)'
                icon={faTint}
                placeholder='Digite a concentração'
                value={concentracao_aminoacido}
                onChange={(e) => mascaraDecimal(e, 'ca')}
                
              />
              <TextArea
                label='Descrição'
                placeholder='Digite a descrição'
                value={descricao_aminoacido}
                onChange={setDescricao_aminoacido}
                maxHeight={100}
                
              />
            </div>
          </Panel>

          <Panel
            key={''}
            header={
              <div>
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontWeight: hormonioReguladorPossuiDados ? 'bold' : 'normal',
                    color: hormonioReguladorPossuiDados ? '#5DA57D' : 'black',
                  }}
                >
                  Hormônio/Regulador
                </p>
              </div>
            }
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Input
                label='Concentração (%)'
                icon={faTint}
                placeholder='Digite a concentração'
                value={concentracao_hormonio_regulador}
                onChange={(e) => mascaraDecimal(e, 'cha')}
               
              />
              <TextArea
                label='Descrição'
                placeholder='Digite a descrição'
                value={descricao_hormonio_regulador}
                onChange={setDescricao_hormonio_regulador}
                maxHeight={100}
              
              />
            </div>
          </Panel>
          <Panel
            key={''}
            header={
              <div>
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontWeight: indutorResistenciaPossuiDados ? 'bold' : 'normal',
                    color: indutorResistenciaPossuiDados ? '#5DA57D' : 'black',
                  }}
                >
                  Indutor de resistência
                </p>
              </div>
            }
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Input
                label='Concentração (%)'
                icon={faTint}
                placeholder='Digite a concentração'
                value={concentracao_indutor_resistencia}
                onChange={(e) => mascaraDecimal(e, 'cir')}
                
              />
              <TextArea
                label='Descrição'
                placeholder='Digite a descrição'
                value={descricao_indutor_resistencia}
                onChange={setDescricao_indutor_resistencia}
                maxHeight={100}
                
              />
            </div>
          </Panel>
          <Panel
            key={''}
            header={
              <div>
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontWeight: biologicosPosseuiDados ? 'bold' : 'normal',
                    color: biologicosPosseuiDados ? '#5DA57D' : 'black',
                  }}
                >
                  Biológicos
                </p>
              </div>
            }
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Input
                label='Concentração (g/kg)'
                icon={faTint}
                placeholder='Digite a concentração'
                value={concentracao_biologicos}
                onChange={(e) => mascaraDecimal(e, 'cb')}
                
              />
              <TextArea
                label='Descrição'
                placeholder='Digite a descrição'
                value={descricao_biologicos}
                onChange={setDescricao_Biologicos}
                maxHeight={100}
               
              />
            </div>
          </Panel>
          <Panel
            key={''}
            header={
              <div>
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontWeight: extratoAlgaPossuiDados ? 'bold' : 'normal',
                    color: extratoAlgaPossuiDados ? '#5DA57D' : 'black',
                  }}
                >
                  Extrato de alga
                </p>
              </div>
            }
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Input
                label='Concentração (%)'
                icon={faTint}
                placeholder='Digite a concentração'
                value={extratoAlga}
                onChange={(e) => mascaraDecimal(e, 'cex')}
               
              />
              <TextArea
                placeholder='Digite o descrição'
                label='Descrição'
                value={extrato_de_alga_descricao}
                onChange={setExtrato_de_alga_descricao}
                maxHeight={50}
                
              />
            </div>
          </Panel>
        </Collapse>
      </Box>
      <TextArea
        placeholder='Digite a observação'
        label='Observação'
        value={observacao}
        onChange={setObservacao}
        
      />
    </>
  )
}
